module.exports = __webpack_public_path__ + "static/img/14054B_1_R_20200812_fit.58e05a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14054B_1_R_20200812_fit.png
// module id = 4Bjj
// module chunks = 0